export default "__VITE_ASSET__6b3fe8d7__"